import { INTERSECTION_THRESHOLD_DEFAULT } from '../tokens/intersection-threshold'

export const thresholdFactory = (threshold: string | null): number[] | number => threshold?.split(',').map(parseFloat) || INTERSECTION_THRESHOLD_DEFAULT
